module.exports = __webpack_public_path__ + "static/media/tablet.6f449543.jpg";